import { ConsortiumRepoImpl } from "domain/repository/ChargeDetailMaintenance/ConsortiumRepoImpl";
import { ChargeTypeRepoImpl } from "domain/repository/ChargeType/ChargeTypeRepoImpl";
import { ResumeSGChargeRepoImpl } from "domain/repository/ResumeSGCharge/ResumeSGChargeRepoImpl";
import { useResumeSGChargeTracked } from "presentation/store/ResumeSGCharge/ResumeSGChargeProvider";
import { ResumeSGChargeVM } from "presentation/viewModel/ResumeSGCharge/ResumeSGChargeVM";
import { useMemo } from "react";

export const useResumeSGChargeVM = () => {
    const [, setResumeSGChargeState] = useResumeSGChargeTracked();
    const resumeSGChargeVM = useMemo(() =>
        ResumeSGChargeVM({
            dispatch: [setResumeSGChargeState],
            resumeSGChargeRepo: ResumeSGChargeRepoImpl(),
            chargeTypeRepo: ChargeTypeRepoImpl(),
            consortiumRepo: ConsortiumRepoImpl(),
        }), [setResumeSGChargeState])

    return resumeSGChargeVM
}